export const LABEL_WEIGHT = {
    400: "400",
    500: "500",
    600: "600",
    700: "700",
}

export const LABEL_TYPE = {
    GENERAL: "GENERAL",
    FORM: "FORM",
}